import {Answer} from "../models/Answer";
import {API} from "./API";

export const loadAnswers = (gameId: string, deviceId: number): Promise<Answer[]> => {
    return API.get<Answer[]>(`answer/${gameId}/${deviceId}`);
};
